/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) 2021 Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import { observer } from 'mobx-react';
import React, { ReactElement } from 'react';
import { Drawer, List, ListItem, ListItemText } from '@material-ui/core';
import CourseNavigationViewStyles from './CourseNavigationViewStyles';
import { CourseNavigationViewModel } from './CourseNavigationViewModel';
import { useViewModel } from '../../../../hooks/useViewModel';
import { FormattedMessage } from 'react-intl';
import ChatUnreadNotificationView from '../../../../components/Chat/ChatUnreadNotificationView';
import { reaction } from 'mobx';

const CourseNavigationView = observer((): ReactElement => {
	const classes = CourseNavigationViewStyles();
	const viewModel: CourseNavigationViewModel = useViewModel(CourseNavigationViewModel);

	reaction(
		() => viewModel.reload,
		async (reload, lastReload) => {
			if (reload !== lastReload && !viewModel.isReloading) {
				viewModel.isReloading = true;
				await viewModel.enableCourse();
				viewModel.isReloading = false;
			}
		}
	);

	return (
		<Drawer
			className={classes.drawer}
			variant='permanent'
			classes={{
				paper: classes.drawerPaper,
			}}>
			<List className={classes.menuList}>
				{viewModel.navbarItems.map((menuItem: string, index: number) => (
					<ListItem
						key={index}
						selected={viewModel.getActiveMenu(menuItem)}
						button
						className={classes.listItem}
						onClick={() => {
							viewModel.navigateToSubPage(index);
						}}>
						<ListItemText>
							<FormattedMessage id={menuItem} />
						</ListItemText>
						{index === 0 && <ChatUnreadNotificationView unreadMessages={viewModel.getUnreadMessages()} />}
					</ListItem>
				))}
			</List>
		</Drawer>
	);
});

export default CourseNavigationView;
